]<template>
  <div id="home1">
    <div class="register_box">
      <div class="zcxingshi">
        <span style="color: #3562e8">认证</span>
      </div>
      <div class="zcxingshi">
        <div class="xixin_jiben">
          <Form
            ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate"
            :label-width="100"
            :inline="true"
          >
            <Row>
              <Col span="12">
                <FormItem label=" 姓  名 " prop="fullName">
                  <Input
                    style="width: 477px"
                    v-model="formValidate.fullName"
                    placeholder="请输入姓名"
                  ></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="手机号" prop="mobile">
                  <Input
                    style="width: 477px"
                    v-model="formValidate.mobile"
                    placeholder="请输入手机号"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12"
                ><FormItem label="身份证号码" prop="cardId">
                  <Input
                    style="width: 477px"
                    v-model="formValidate.cardId"
                    placeholder="请输入身份证号码"
                  ></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="性别" prop="sex">
                  <Select
                    @on-change="cahnge1"
                    style="width: 477px"
                    v-model="formValidate.sex"
                    placeholder=""
                  >
                    <Option :value="1">男</Option>
                    <Option :value="2">女</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="邮寄地址" prop="address">
                  <Input
                    style="width: 477px"
                    v-model="formValidate.address"
                    placeholder="请输入邮寄地址"
                  ></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="电子邮箱">
                  <Input
                    style="width: 477px"
                    v-model="formValidate.mail"
                    placeholder="请输入电子邮箱"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="执业地区">
                  <Select
                    v-model="formValidate.comProvince"
                    style="width: 160px"
                    placeholder="请选择省份"
                    @on-change="changesheng()"
                  >
                    <Option
                      v-for="(item, index) in provinceArr"
                      :key="index"
                      :value="item.code"
                      >{{ item.text }}</Option
                    >
                  </Select>
                  <Select
                    v-model="formValidate.comCity"
                    style="width: 160px"
                    placeholder="请选择城市"
                    @on-change="changeCity(formValidate.comCity)"
                  >
                    <Option
                      v-for="(item, index) in citiesArr"
                      :key="index"
                      :value="item.code"
                      >{{ item.text }}</Option
                    >
                  </Select>
                  <Select
                    v-model="formValidate.comCounty"
                    style="width: 160px"
                    placeholder="请选择区县"
                  >
                    <Option
                      v-for="(item, index) in countyArr"
                      :key="index"
                      :value="item.code"
                      >{{ item.text }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="工作单位">
                  <Input
                    style="width: 477px"
                    v-model="formValidate.companyName"
                    placeholder="请工作单位"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="执业范围">
                    <Select v-model="formValidate.jobId" style="width: 477px">
                        <Option
                        v-for="item in cityList"
                        :value="item.value"
                        :key="item.label"
                        >{{ item.label }}</Option
                        >
                    </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="最高学历">
                  <Select
                    v-model="formValidate.educationBackground"
                    @on-change="cahnge1"
                    style="width: 477px"
                  >
                    <Option
                      v-for="(item, index) in data"
                      :value="item.value"
                      :key="index"
                      >{{ item.label }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="所学专业">
                  <Input
                    style="width: 477px"
                    v-model="formValidate.major"
                    placeholder=""
                  ></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="专业类别">
                  <Select style="width: 480px" v-model="formValidate.majorId">
                    <Option
                      :value="item.id"
                      v-for="(item, index) in list"
                      :key="index"
                      >{{ item.majorName }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row style="display: flex; justify-content: center"
              ><Button type="primary" class="renzheng_but" @click="renzheng()">提交</Button></Row
            >
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "components/common/Header";
import Cookies from "js-cookie";

import { sendMessageToUser,getCityList,} from "network/home.js";
import { ItemImgList } from "common/minix";
import { getSelectMajor, queryJob, getNews} from "../../../network/LPersonal";
import { authenticationUser } from "../../../network/order2";

import md5 from "js-md5";
export default {
  name: "Register",

  components: {
    NavBar,
  },

  mixins: [ItemImgList],

  data() {
    return {
      formItem: {},
      list: [],
      list1: [],
      requiredd: true,
      loading: false,
      codes: "获取验证码",
      timer: null,
      rou: 0,
      provinceArr: [],
      citiesArr: [],
      countyArr: [],
      cityList: [
        {
          value: 1,
          label: "生产",
        },
        {
          value: 2,
          label: "经营",
        },
        {
          value: 3,
          label: "批发",
        },
        {
          value: 4,
          label: "使用",
        },
        {
          value: 5,
          label: "教育",
        },
        {
          value: 6,
          label: "科研",
        },
        {
          value: 7,
          label: "管理",
        },
        {
          value: 8,
          label: "其他",
        },
      ],
      //个人
      formValidate: {
        //专业名称
        majorName:'',
        //专业Id
        majorId:"",
        county:'',
        city: "",
        province:'',
        //身份证号码
        cardId: "",
        //密码
        mail: "",
        //确认密码
        mail1: "",
      
        //手机号
        mobile: "",
        yzm: "",
        yname: "",
        //性别
        sex: "",
        // 职称类别
        radio: 1,
        //姓名
        fullName: "",
        //执行地区
        workArea: "",
        //验证码
        checkCode: "",
        //执业范围
        jobName: "经营",
        //工作单位
        companyName: "",
        lei: "",
        educationBackground: null,
        //所学专业
        major: "",
        classify: "",
        ming: "",
        dizhi: "",
        //年龄
        age: "",
        //电话
        tel: "",
        //电子邮箱
        email: "",
        //邮寄地址
        address: "",
        //职务
        zhiwu: "",
        //邮编
        postCode: "",
        //技术岗位
        gang: "",
        //开票类型
        kai: "",
        //发票抬头
        tai: "",
        //纳税人识别号
        hao: "",
      },
      //企业
      qiyealidate: {
        //账号
        zh: "",
        //手机号
        sj: "",
        //负责人姓名
        fz: "",
        //密码
        mm: "",
        //性别
        sex: "",
        //确认密码
        qr: "",
        //单位名称
        dw: "",
        //单位地址
        dz: "",
        //所属行政区域
        qy: "",
        //单位电话
        dh: "",
        //邮政编码
        yb: "",
        //开票类型
        kp: "",
        //发票抬头
        fp: "",
        //纳税识别号
        ns: "",
      },
      data: [
        {
          value: 8,
          label: "博士后",
        },
        {
          value: 7,
          label: "博士",
        },
        {
          value: 6,
          label: "硕士",
        },
        {
          value: 5,
          label: "本科",
        },
        {
          value: 4,
          label: "大专",
        },
        {
          value: 3,
          label: "高中",
        },
        {
          value: 2,
          label: "初中",
        },
        {
          value: 1,
          label: "小学",
        },
      ],
      ruleValidate: {
        cardId: [
          {
            required: true,
            message: "身份证号码不能为空",
            trigger: "blur",
          },
        ],
        fullName: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: "blur",
          },
        ],
        checkCode: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "地址不能为空",
            trigger: "blur",
          },
        ],
      },
      isCode1: "",
      type: 0,
      educationBackground: "",
      sex: "",
      chengshi:"",
      shengfen:"",
      quxian:""
    };
  },
  activated() {
    this.$store.commit("setTabBarShow", false);
        this.queryProvince();
        this.getUserInfo();
        this.getSelectMajor();
        this.queryJob();
  },
  //组件创建前调用的生命周期
  beforeCreate() {},
  deactivated() {
    this.$store.commit("setTabBarShow", true);
  },


  methods: {
      getUserInfo() { // 获取用户信息
        getNews({
            userId: Cookies.get(`admin-userId`)
        }).then((res) => {
          console.log(res,"信息");
            const userinfo = res.data.data.user;
            this.formValidate.fullName = userinfo.fullName;
            this.formValidate.mobile = userinfo.mobile;
            this.formValidate.address = userinfo.administrativeRegion;
            this.formValidate.cardId = userinfo.idCard;
            this.formValidate.sex = userinfo.sex;
            this.formValidate.mail = userinfo.mail;
            this.formValidate.comCity = userinfo.comCity;
            this.formValidate.comCounty = userinfo.comCounty;
            this.formValidate.comProvince = userinfo.comProvince;
            this.formValidate.educationBackground = userinfo.educationBackground;
            this.formValidate.companyName = userinfo.companyName;
            this.formValidate.major = userinfo.major;
            this.formValidate.jobId = userinfo.jobId;
            
        });
      },
      changesheng() {
        this.citiesArr = this.provinceArr[0].children;
        this.comProvincecode = this.provinceArr[0].code;
      },
      changeCity(e) {
        console.log(e);
        this.citiesArr.forEach((item, i) => {
          if (e == item.code) {
            this.countyArr = this.citiesArr[i].children;
            this.comCitycode = this.citiesArr[i].code;
          }
        });
      },
      getpost(e) {
        console.log(e);
        this.countyArr.forEach((item, i) => {
          if (e == this.countyArr[i].text) {
            this.formValidate.postCode = this.countyArr[i].postCode;
            this.comCountycode = this.countyArr[i].code;
          }
        });
      },
      queryProvince() {
        getCityList().then((res) => {
          console.log(res, "省");
          this.provinceArr = res.data.data;
          this.changesheng();
          this.changeCity(this.formValidate.comCity);
          this.provinceArr.forEach((item,i)=>{
              if(this.formValidate.comProvince==item.code){
                this.shengfen = item.text
                item.children.forEach((a,b)=>{
                  if(this.formValidate.comCity==a.code){
                    this.chengshi = a.text
                    a.children.forEach((c,d)=>{
                      if(this.formValidate.comCounty==c.code){
                      this.quxian = c.text
                      }
                    })
                  }
                })
              }
            })
            console.log(this.shengfen,this.chengshi,this.quxian);
            this.formValidate.address = this.shengfen+this.chengshi+this.quxian

        });
      },
      renzheng(){
        this.$refs.formValidate.validate((valid) => {
          if(valid){
            authenticationUser({
                fullName:this.formValidate.fullName,//姓名
                idCard:this.formValidate.cardId,//身份证号
                mobile:this.formValidate.mobile,//电话
                checkCode:this.formValidate.checkCode,//验证码
                jobId:this.formValidate.jobId,//执业范围Id
                workArea:this.formValidate.province + this.formValidate.city +this.formValidate.county,//执业地区
                type:0,//用户类型
                postCode:this.formValidate.postCode,//邮编,
                mail:this.formValidate.mail,//电子邮箱
                major:this.formValidate.major,//所学专业
                companyName:this.formValidate.companyName,//工作单位
                educationBackground:this.educationBackground,//最高学历
                sex:this.formValidate.sex,//性别
                majorId:this.formValidate.majorId,//专业Id
                
            }).then(res=>{
                console.log(res,"用户认证");
                if(res.data.code==200){
                  this.$message.success(res.data.msg)
                  this.$router.push("/index")
                }else{
                    this.$message.error(res.data.msg)
                }
            })
          }
          else{
            this.$message.error('请输入完整信息')
          }
        })
      },
    cahnge() {
      this.$forceUpdate();
    },
    cahnge1() {
      console.log(this.educationBackground);
      console.log(this.formValidate.sex);
    },
    onInput() {
      this.$forceUpdate();
    },
    focusChange(e) {
      this.showKeyboard = true;
      this.show = true;
    },
    onConfirm(value, index) {
      this.data.sex = value;
      this.showPicker = false;
    },
    //选择性别
    selectSex(e) {
      this.data;
    },
    //获取手机验证码
    getCode() {
      this.loading = false;
      let isCode = /^1[34578][0-9]{9}$/;
      console.log(this.formValidate.mobile);
      if (isCode.test(this.formValidate.mobile)) {
        this.sendMessageToUser();
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.codes = TIME_COUNT;
          this.timer = setInterval(() => {
            if (this.codes > 0 && this.codes <= TIME_COUNT) {
              this.codes--;
            } else {
              this.codes = "获取验证码";
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      } else {
        this.$message({
          message: "手机号格式不正确!",
          type: "warning",
        });
      }
    },

    sendMessageToUser() {
      sendMessageToUser(this.formValidate.mobile).then((r) => {
        console.log(r, "");
        this.isCode1 = r.data.data;
        if (r.data.code === 200) {
          this.$message({
            message: "发送成功",
            type: "success",
          });
        }
      });
    },
    isCardNo(cardId) {
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(cardId) === false) {
        this.$message({
          message: "身份证输入不合法",
          type: "success",
        });

        return false;
      }
    },
    //下一步
    nextze() {
      let iscardId = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (iscardId.test(this.formValidate.cardId)) {
        
      } else {
        this.$message({
          message: "身份证号码格式不正确!",
          type: "warning",
        });
      }
    },
    onDelete(e) {
      this.data.checkCode = "e";
    },
    validator(val) {
      this.isID = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
    },
    getSelectMajor() {
      getSelectMajor().then((r) => {
        console.log(r, "专业类别");
        this.list = r.data.data;
      });
    },
    queryJob() {
      queryJob().then((r) => {
        console.log(r, "执业范围");
        this.list1 = r.data.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
#home1 {
  background-image: url("../../../assets/img/login/loginbg.png");
  width: 1903px;
  height: 915px;
  background-size: 100% 100%;
  padding-top: 95px;
}
input {
  font-size: 20px;
}

.register_box {
  width: 1480px;
  height: 750px;
  background: #ffffff;
  box-shadow: 0px 0px 36px 18px rgba(170, 203, 255, 0.11);
  border-radius: 10px;
  margin-left: 200px;
  padding-top: 58px;
  padding-left: 60px;
}
.zcxingshi {
  height: 50px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  position: relative;
}

.gun {
  width: 27px;
  height: 8px;
  background: #3562e8;
  border-radius: 4px;
  position: absolute;
  left: 46px;
  bottom: 5px;
}
.gun1 {
  width: 27px;
  height: 8px;
  background: #3562e8;
  border-radius: 4px;
  position: absolute;
  left: 216px;
  bottom: 5px;
}

.bujinqi {
  width: 1300px;
  height: 70px;
  margin-top: 60px;
  margin-left: 100px;
}
// .qzhuce {
//   height: 500px;
//   border: red 1px solid;
// }

.xixin_zhuce {
  width: 500px;
  height: 500px;
  margin-left: 500px;
}

label {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.next_zhuce {
  width: 180px;
  height: 48px;
  background: #3562e8;
  border-radius: 8px;
  margin-top: -50px;
  margin-left: 580px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.prev_shangzhuce {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 673px;
}
.next_xiazhuce {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: 44px;
  margin-left: 520px;
  cursor: pointer;
}
.prev_shangqiye {
  width: 180px;
  height: 46px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #3562e8;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 30px;
  margin-left: 606px;
  cursor: pointer;
}

.next_xiaqiye {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 393px;
  cursor: pointer;
}
.prev_shang {
  width: 180px;
  height: 46px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #3562e8;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 673px;
  cursor: pointer;
}
.next_xia {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 429px;
  cursor: pointer;
}
.prev_shangone {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  cursor: pointer;
  margin-left: 673px;
}
.next_xiaone {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 429px;
  cursor: pointer;
}
.prev_fapiao1 {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 173px;
  cursor: pointer;
}
.prev_fapiao2 {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 173px;
  cursor: pointer;
}
.next_fapiao3 {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -45px;
  margin-left: 403px;
  cursor: pointer;
}
.prev_fapiao {
  width: 180px;
  height: 46px;
  background: #fff;
  border: 1px solid #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3562e8;
  text-align: center;
  line-height: 46px;
  margin-top: 100px;
  margin-left: 450px;
  cursor: pointer;
}
.next_fapiao {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  text-align: center;
  line-height: 46px;
  margin-top: -44px;
  margin-left: 199px;
  cursor: pointer;
}
#gerenfapiao {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  margin-left: 300px;
}
#qiyefapiao {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  margin-left: 300px;
}
.xixin_youji {
  margin-left: 100px;
}
.prev_fapiao[data-v-7bebb8ff] {
  margin-left: 366px;
}
.next_fapiao[data-v-7bebb8ff] {
  margin-left: 88px;
}
#aa {
  margin-left: 88px;
}
#bb {
  margin-left: 166px;
}
.shoujihao {
  margin-left: 44px;
}
.qiye_zhuce {
  margin-left: 111px;
}
#ge {
  color: #3562e8;
}
.renzheng_but {
  width: 180px;
  height: 46px;
  background: #3562e8;
  border-radius: 8px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
</style>